/* eslint-disable react/no-unescaped-entities -- texte juridique FR (Politique de Cookies) avec apostrophes, rendu correct */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CookiesPage() {
    return (
        <div className="min-h-screen bg-[#0A0A0A] text-white">
            <div className="fixed inset-0 pointer-events-none">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#681793]/20 rounded-full blur-[128px]" />
            </div>

            <header className="relative z-50 border-b border-border">
                <nav className="max-w-4xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="text-xl font-extrabold bg-gradient-to-r from-[#681793] to-[#FF914D] bg-clip-text text-transparent">Homly.</Link>
                        <Link to="/" className="text-sm text-muted-foreground hover:text-white flex items-center gap-2"><ArrowLeft className="w-4 h-4" />Retour</Link>
                    </div>
                </nav>
            </header>

            <main className="relative max-w-4xl mx-auto px-4 py-12">
                <h1 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-[#681793] to-[#FF914D] bg-clip-text text-transparent">Politique de Cookies</h1>
                <p className="text-sm text-muted-foreground mb-10">Derniere mise a jour : 23 mars 2026</p>

                <div className="space-y-8 text-white/80 text-[13px] leading-[1.8]">

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">1. Qu'est-ce qu'un cookie ?</h2>
                        <p>Un cookie est un petit fichier texte depose sur votre terminal (ordinateur, smartphone, tablette) lors de votre visite sur un site web. Il permet au site de memoriser certaines informations relatives a votre navigation pour faciliter vos visites ulterieures et rendre le site plus fonctionnel.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">2. Cookies utilises par Homly</h2>
                        <p>La plateforme Homly utilise <strong>exclusivement des cookies strictement necessaires</strong> au fonctionnement du service. Nous n'utilisons aucun cookie publicitaire, de suivi marketing ou de profilage.</p>
                        <table className="w-full mt-3 text-xs border border-white/10 rounded-lg overflow-hidden">
                            <thead className="bg-white/5">
                                <tr>
                                    <th className="text-left p-3 text-white">Nom</th>
                                    <th className="text-left p-3 text-white">Finalite</th>
                                    <th className="text-left p-3 text-white">Duree</th>
                                    <th className="text-left p-3 text-white">Type</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5">
                                <tr><td className="p-3">session_token</td><td className="p-3">Authentification et maintien de la session utilisateur</td><td className="p-3">24 heures</td><td className="p-3">Strictement necessaire</td></tr>
                                <tr><td className="p-3">homly_theme</td><td className="p-3">Preference d'affichage (mode sombre)</td><td className="p-3">1 an</td><td className="p-3">Strictement necessaire</td></tr>
                                <tr><td className="p-3">homly_visitor_session</td><td className="p-3">Identification anonyme des visiteurs du Homly Reseau (pas de donnees personnelles)</td><td className="p-3">Session</td><td className="p-3">Strictement necessaire</td></tr>
                                <tr><td className="p-3">homly_dashboard_layout</td><td className="p-3">Memorisation de la personnalisation du tableau de bord</td><td className="p-3">1 an</td><td className="p-3">Fonctionnel</td></tr>
                            </tbody>
                        </table>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">3. Stockage local (localStorage)</h2>
                        <p>En complement des cookies, Homly utilise le stockage local du navigateur (localStorage) pour :</p>
                        <ul className="list-disc pl-6 mt-2 space-y-1">
                            <li>Conserver votre token d'authentification (JWT) pour maintenir votre session.</li>
                            <li>Stocker vos preferences d'interface (disposition du tableau de bord, filtres).</li>
                            <li>Conserver temporairement des brouillons de mandats en cours de creation.</li>
                        </ul>
                        <p className="mt-2">Ces donnees sont stockees uniquement sur votre appareil et ne sont pas transmises a des tiers.</p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">4. Cookies tiers</h2>
                        <p><strong>Homly n'utilise aucun cookie tiers</strong> a des fins publicitaires ou de suivi. Toutefois, les services suivants peuvent deposer leurs propres cookies lorsque vous interagissez avec eux :</p>
                        <ul className="list-disc pl-6 mt-2 space-y-1">
                            <li><strong>Google Maps</strong> : lorsque vous cliquez sur un lien "Voir sur Google Maps" depuis un profil public. Politique de cookies de Google : <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-[#FF914D] hover:underline">policies.google.com/technologies/cookies</a>.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">5. Gestion des cookies</h2>
                        <p>Les cookies strictement necessaires ne peuvent pas etre desactives car ils sont indispensables au fonctionnement de la Plateforme. Sans eux, vous ne pourriez pas vous connecter ni utiliser le service.</p>
                        <p className="mt-2">Vous pouvez toutefois configurer votre navigateur pour refuser les cookies. Dans ce cas, certaines fonctionnalites de la Plateforme pourraient ne pas fonctionner correctement.</p>
                        <p className="mt-2"><strong>Parametrage par navigateur :</strong></p>
                        <ul className="list-disc pl-6 mt-1 space-y-1">
                            <li>Chrome : chrome://settings/cookies</li>
                            <li>Firefox : about:preferences#privacy</li>
                            <li>Safari : Preferences &gt; Confidentialite</li>
                            <li>Edge : edge://settings/privacy</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">6. Base legale</h2>
                        <p>Conformement a l'article 82 de la loi Informatique et Libertes et aux lignes directrices de la CNIL :</p>
                        <ul className="list-disc pl-6 mt-2 space-y-1">
                            <li>Les cookies <strong>strictement necessaires</strong> sont deposes sans consentement prealable (exemption prevue par la directive ePrivacy).</li>
                            <li>Aucun cookie non essentiel n'est depose, donc aucun bandeau de consentement n'est requis.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-white mb-3">7. Contact</h2>
                        <p>Pour toute question relative aux cookies : <strong>contact@homly.pro</strong></p>
                        <p className="mt-2">Pour plus d'informations sur le traitement de vos donnees, consultez notre <Link to="/privacy" className="text-[#FF914D] hover:underline">Politique de Confidentialite</Link>.</p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-border">
                    <p className="text-sm text-muted-foreground">Homly Lab SAS - contact@homly.pro</p>
                </div>
            </main>
        </div>
    );
}
